import { c as _c } from "react/compiler-runtime";
import { resolve } from "../registry";
import { MAX_RENDER_DEPTH, type RenderContext } from "../types";
import { ValueErrorBoundary } from "../ValueErrorBoundary";
import { JsonFallback } from "../JsonFallback";
interface RegistryValueProps {
  value: unknown;
  ctx: RenderContext;
}

/** Resolves one value to its best renderer and renders it, wrapped in an error
 *  boundary that degrades to the JSON fallback if the renderer throws. */
export function RegistryValue(t0) {
  const $ = _c(14);
  const {
    value,
    ctx
  } = t0;
  if (ctx.depth > MAX_RENDER_DEPTH) {
    let t1;
    if ($[0] !== ctx || $[1] !== value) {
      t1 = <JsonFallback value={value} ctx={ctx} />;
      $[0] = ctx;
      $[1] = value;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  let t1;
  if ($[3] !== ctx || $[4] !== value) {
    t1 = resolve(value, ctx);
    $[3] = ctx;
    $[4] = value;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const renderer = t1;
  let t2;
  if ($[6] !== ctx || $[7] !== renderer.Component || $[8] !== value) {
    t2 = <renderer.Component value={value} ctx={ctx} />;
    $[6] = ctx;
    $[7] = renderer.Component;
    $[8] = value;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== ctx || $[11] !== t2 || $[12] !== value) {
    t3 = <ValueErrorBoundary value={value} ctx={ctx}>{t2}</ValueErrorBoundary>;
    $[10] = ctx;
    $[11] = t2;
    $[12] = value;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}